// Real-user monitoring (RUM) client → /api/rum/beacon.
// Captures client-perceived API latency, Web Vitals, and crash-free sessions.
// Everything is best-effort and must never affect the app.
import { onLCP, onINP, onCLS, onFCP, onTTFB } from "web-vitals";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function sid() {
  let s = sessionStorage.getItem("sc_sid");
  if (!s) {
    s = "sess_" + Math.random().toString(36).slice(2) + Date.now().toString(36);
    sessionStorage.setItem("sc_sid", s);
  }
  return s;
}

let samples = [];
let vitals = [];
let crashed = false;
let started = false;

// Collapse ids/hashes so routes group cleanly (e.g. /api/titles/abc123 → /api/titles/:id).
function normRoute(route) {
  return (route || "")
    .split("?")[0]
    .replace(/\/[0-9a-f]{16,}/gi, "/:id")
    .replace(/\/\d+/g, "/:id")
    .slice(0, 80);
}

export function recordSample(route, ms, status) {
  try {
    samples.push({ route: normRoute(route), ms: Math.max(0, Math.round(ms)), status: status || 0 });
    if (samples.length >= 50) flush();
  } catch { /* ignore */ }
}

export function markCrash() {
  crashed = true;
  flush();
}

function flush() {
  if (!samples.length && !vitals.length && !crashed) return;
  const body = JSON.stringify({ session_id: sid(), samples, vitals, crashed });
  samples = [];
  vitals = [];
  try {
    const gate = localStorage.getItem("sc_gate_token");
    fetch(API + "/rum/beacon", {
      method: "POST",
      keepalive: true,
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        ...(gate ? { "X-Site-Gate": gate } : {}),
      },
      body,
    }).catch(() => {});
  } catch { /* ignore */ }
}

export function initRum() {
  if (started || typeof window === "undefined") return;
  started = true;
  try {
    const rec = (name) => (m) => vitals.push({ name, value: m.value });
    onLCP(rec("LCP"));
    onINP(rec("INP"));
    onCLS(rec("CLS"));
    onFCP(rec("FCP"));
    onTTFB(rec("TTFB"));
  } catch { /* ignore */ }
  setInterval(flush, 15000);
  window.addEventListener("visibilitychange", () => { if (document.visibilityState === "hidden") flush(); });
  window.addEventListener("pagehide", flush);
}
